import { render, staticRenderFns } from "./CreditKarma.vue?vue&type=template&id=066c2ce2&scoped=true"
import script from "./CreditKarma.vue?vue&type=script&lang=js"
export * from "./CreditKarma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c2ce2",
  null
  
)

export default component.exports